export function definePlugin(plugin) {
  return plugin;
}
